import { useTV } from "../../hooks/useTV";
import { useEffect, useRef } from "react";
import { buttonIds } from "../../config/buttonIds";
const GetStarted = ({ setStarted }) => {
  const { isTv } = useTV();
  const buttonRef = useRef(null);

  useEffect(() => {
    if (isTv && buttonRef.current) {
      buttonRef.current.focus();
    }
  }, [isTv, buttonRef]);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      setStarted(true);
    } else if (isTv && e.key === "ArrowDown") {
      setStarted(true);
    } else if (isTv && (e.key === "ArrowUp" || e.key === "ArrowRight")) {
      // Focus the WiFi button
      const wifiButton = document.getElementById("wifi-button");
      if (wifiButton) {
        wifiButton.focus();
      }
    }
  };

  return (
    <div
      style={{
        display: "flex",
        height: "100vh",
        width: "100vw",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "20px",
        position: "relative",
      }}
    >
      <img
        style={
          isTv
            ? {
                position: "absolute",
                top: "-115px",
                left: "0px",
                width: "100%",
                height: "auto",
                objectFit: "cover",
                zIndex: "0",
                opacity: "1",
                transition: "opacity 2s",
              }
            : {
                position: "absolute",
                top: "0",
                left: "0",
                width: "100%",
                height: "100%",
                objectFit: "cover",
                zIndex: "0",
                opacity: 1,
                transition: "opacity 2s",
              }
        }
        src="/static/connection-2.png"
        alt=""
      />
      <button
        id={buttonIds.getStartedButton}
        ref={buttonRef}
        onClick={() => setStarted(true)}
        onKeyDown={handleKeyDown}
        style={{
          padding: 0,
          border: "none",
          background: "none",
          cursor: "pointer",
          position: "absolute",
          top: isTv ? "-115px" : "0",
          left: "0",
          width: "100%",
          height: isTv ? "auto" : "100%",
          zIndex: "2",
          outline: isTv ? "none" : undefined,
        }}
      >
        <img
          style={
            isTv
              ? {
                  width: "100%",
                  height: "auto",
                  objectFit: "cover",
                  opacity: "1",
                  transition: "opacity 2s",
                }
              : {
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  opacity: 1,
                }
          }
          src={isTv ? "/static/connection-bg2.png" : "/static/connection-bg.png"}
          alt=""
        />
      </button>
    </div>
  );
};

export default GetStarted;
